export default "__VITE_PUBLIC_ASSET__21fa7fa6__"